export const TEMPLATE_NAMES = {
  PDP: 'AccommodationPage',
  CountryPage: 'CountryPage',
  RegionPage: 'RegionPage',
  CityPage: 'CityPage',
  ContentPage: 'ContentPage',
  CollectionPage: 'CollectionPage',
  BookingStepPage: 'BookingStepPage',
  BookingStepExternalFlightConfirmationPage: 'BookingStepExternalFlightConfirmationPage',
  BookingStepMandatoryPaymentPage: 'BookingStepMandatoryPaymentPage',
  BrandSummerHomePage: 'BrandSummerHomePage',
  BrandWinterHomePage: 'BrandWinterHomePage',
  HomePage: 'HomePage',
  SearchPage: 'SearchPage',
  FavoritePage: 'FavoritePage',
  DestinationsPage: 'DestinationsPage',
  AccoTemplate: 'AccoTemplate',
  AccommodationPage: 'AccommodationPage',
}

export type TemplateName = typeof TEMPLATE_NAMES[keyof typeof TEMPLATE_NAMES]

const DESTINATION_TEMPLATE_NAMES: TemplateName[] = [
  TEMPLATE_NAMES.CountryPage,
  TEMPLATE_NAMES.RegionPage,
  TEMPLATE_NAMES.CityPage,
]

export function isDestinationTemplateName(templateName: string): templateName is TemplateName {
  return DESTINATION_TEMPLATE_NAMES.includes(templateName as TemplateName)
}

export function isProductTemplateName(templateName: string): templateName is TemplateName {
  return templateName === TEMPLATE_NAMES.PDP
}
